import { TeamPage as TeamPageComponent } from '@vyce/core/src/views/teamPage';
import { TeamModuleProvider, TeamsDashboardModuleProvider } from '@vyce/core/src/contexts';

import { useTeamPageData } from './hooks';
import { useTeamsDashboardData } from '../teamsDashboardModule/hooks';

export const TeamModule = () => {
  const data = useTeamPageData();

  const { contextOptions } = useTeamsDashboardData();

  return (
    <TeamsDashboardModuleProvider value={contextOptions}>
      <TeamModuleProvider value={data}>
        <TeamPageComponent />
      </TeamModuleProvider>
    </TeamsDashboardModuleProvider>
  );
};
